module.exports = __webpack_public_path__ + "static/media/460GriffinStNW_2018-06-05_30.6a0d9c22.jpg";